// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"275":"064145e8","2084":"16089f29","8071":"a53e623e"}[chunkId] + ".chunk.css";
};